import { I18nContextType } from '../../libs/i18n';

export type FaqItem = {
  title: string;
  description: string;
};

const MAX_SECTIONS_NUMBER = 10;

export const getFaqItems = (
  i18n: I18nContextType,
  sheetName: string,
  query: string
): FaqItem[] => {
  const faqItems: FaqItem[] = [];

  for (let i = 1; i <= MAX_SECTIONS_NUMBER; i++) {
    const title = i18n.t(`dynamic.${sheetName}.${query}.faqTitle_${i}`);
    const description = i18n.t(
      `dynamic.${sheetName}.${query}.faqDescription_${i}`
    );

    if (!title || !description) {
      break;
    }

    faqItems.push({
      title,
      description,
    });
  }

  return faqItems;
};
